import React from 'react';
import classNamesBind from "classnames/bind";
import styles from './EdutechKoreaFairCompanyData.module.scss';
import {useSelector} from "react-redux";
import {navigate} from "hookrouter";
import { I18nState } from '../../../../redux/I18n';
import { BizNoDataTable } from '../../../shares/bizNoDataTable/BizNoDataTable';
import { EdutechKoreaFairCompany } from '../../../../graphql/types';
import { CompanyDataUtil } from '../../../../utils/companyDataUtil/CompanyDataUtil';
import { Pipe } from '../../../../utils/pipe/pipe';

const cx = classNamesBind.bind(styles);

interface Props {
    companyList: EdutechKoreaFairCompany[]
}

export const EdutechKoreaFairCompanyData = (props: Props) => {
    const langCode = useSelector<any, I18nState>(state => state.i18n).langCode;


    return (
        <>
            {props.companyList.length === 0 && <BizNoDataTable/>}

            <div className={cx('cont')}>

                {props.companyList.map((value, index) => {
                    const companyData = CompanyDataUtil.getValue(langCode, value.companyData);
                    return (
                        <div key={index}
                             className={cx(value.isPaid ? 'box-full' : 'box-half', 'p-5')}
                             onClick={() => navigate(`/edutechkoreafair/detail/${value.id}`)}>
                            
                            <div className={cx('btn-company')}>
                                <img src={companyData.logoUrl} alt='logo'/>

                                <div className={cx('info')}>
                                    <div className={cx('company-nm')}>{companyData.companyNm}</div>
                                    <div className={cx('space')}/>
                                    <div className={cx('nation')}>
                                        <span className={cx('flag', 'flag-icon', `flag-icon-${companyData.nationCode.toLowerCase()}`)}/>
                                        <span className={cx('nm')}>{Pipe.nationNm(companyData.nationCode)}</span>
                                    </div>
                                    <div className={cx('catchphrase')}>
                                        {companyData.catchphrase}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </>

    )
}
